import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { animeLibrary } from '@/mocks/animeData';

const editorNotes: Record<string, string> = {
  'star-echo':
    '开篇三集就把世界观立住，之后每集都在推进主线。画面调度是这一季里最讲究的，值得留意它的构图与光影。',
  'kite-wind':
    '短小但完整。没有大转折，靠对白和季节感堆出情绪，适合在心静下来的时候看，一遍就够，但会记得很久。',
  'midnight-diner':
    '一道菜、一桌客、一段人生。形式简单却很稳，每集都能独立成立，是那种可以随时点开、随时停下的作品。',
};

export default function PicksSection() {
  const picks = animeLibrary.filter((item) => item.isPick);

  return (
    <section id="picks" className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Editor's Picks"
            title="编辑精选"
            description="不按热度、只按“值得一看”挑出的三部。每部都附上一句实话：它适合什么时候看、看的时候该留意什么。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {picks.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <article className="group h-full flex flex-col rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-colors">
                <div className="relative w-full h-64 overflow-hidden bg-background-200">
                  <img
                    src={item.poster}
                    alt={`${item.title} 编辑精选封面`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[11px] bg-accent-500 text-background-50">
                    精选 {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="flex-1 flex flex-col p-5">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500">{item.year}</span>
                  </div>
                  <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                      {item.genre}
                    </span>
                    <span className="px-2 py-0.5 rounded-full bg-background-200 text-foreground-700">
                      {item.episodes}
                    </span>
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                  <blockquote className="mt-4 pt-4 border-t border-background-200 text-xs md:text-sm text-foreground-700 leading-relaxed">
                    <i className="ri-double-quotes-l text-accent-500 mr-1"></i>
                    {editorNotes[item.id]}
                  </blockquote>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}